import { worldViewerWindow } from '../const';
import { getGyroActiveToggle, getVideoGainNode, setGyroActiveToggle } from './dataOps';
import { getVideo } from './domOps';
import { requestToToggleActivateGyro, sendGamepadData } from './moduleCaller';
/**
 * @remarks
 * Videoの音声をセット
 * @param volume {number}
 */ export const hel_video_SetVolume = (volume)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    const gainNode = getVideoGainNode();
    if (gainNode === undefined) {
        // iOS/Mac以外ではgainNodeが生成されていなくてundefinedになるため、直接video要素に設定する
        video.volume = volume;
        return;
    }
    // worldViewerWindow.g_Video.volume = volume;
    gainNode.gain.value = volume;
};
const toggleGyroActive = ()=>{
    setGyroActiveToggle(!getGyroActiveToggle());
    requestToToggleActivateGyro();
    return getGyroActiveToggle();
};
/**
 * @remarks
 * ジャイロを変更
 * XRWorldIngame, JRWorld_web, WorldViewerにて未使用
 */ worldViewerWindow.toggleGyroActiveRequest = ()=>{
    if (getGyroActiveToggle()) {
        toggleGyroActive();
        return;
    }
    if (DeviceOrientationEvent && DeviceOrientationEvent.requestPermission && typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission().then((permissionState)=>{
            if (permissionState === 'granted') {
                toggleGyroActive();
            }
        }).catch(console.error);
    } else {
        toggleGyroActive();
    }
};
/**
 * ゲームパッドコントローラーを取得
 */ worldViewerWindow.g_gamepadController = {};
worldViewerWindow.getGamepadControllers = ()=>{
    if (worldViewerWindow.g_gamepadController == null) {
        return [];
    }
    return worldViewerWindow.g_gamepadController;
};
/**
 * ゲームパッドコントローラーを取得
 */ worldViewerWindow.g_gamepadController = [];
worldViewerWindow.getGamepadControllers = ()=>{
    return worldViewerWindow.g_gamepadController;
};
/**
 * ゲームパッドコントローラーInfoを取得
 */ worldViewerWindow.g_gamepadInfoArray = [];
worldViewerWindow.getGamepadInfoArray = ()=>{
    return worldViewerWindow.g_gamepadInfoArray;
};
const scanGamepads = ()=>{
    const controllers = worldViewerWindow.getGamepadControllers();
    const gamepads = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads() : [];
    for(let i = 0; i < gamepads.length; i++){
        if (gamepads[i] && gamepads[i].index in controllers) {
            controllers[gamepads[i].index] = gamepads[i];
        }
    }
};
export const updateGamepadsInfo = ()=>{
    // シーンファイルでusegamepadが有効になっていないのなら処理を行わない
    if (worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_IsUseGamePad, "") != 1) {
        return;
    }
    scanGamepads();
    const controllers = worldViewerWindow.getGamepadControllers();
    const gamepadInfoArray = worldViewerWindow.getGamepadInfoArray();
    for(let j in controllers){
        const controller = controllers[j];
        for(let i = 0; i < controller.buttons.length; i++){
            const val = controller.buttons[i];
            if (typeof val == "object") {
                var _j;
                gamepadInfoArray[j] = (_j = gamepadInfoArray[j]) !== null && _j !== void 0 ? _j : [];
                var _buttons;
                gamepadInfoArray[j].buttons = (_buttons = gamepadInfoArray[j].buttons) !== null && _buttons !== void 0 ? _buttons : [];
                var _i;
                gamepadInfoArray[j].buttons[i] = (_i = gamepadInfoArray[j].buttons[i]) !== null && _i !== void 0 ? _i : {};
                gamepadInfoArray[j].buttons[i].pressed = val.pressed;
                if ('touched' in val) {
                    gamepadInfoArray[j].buttons[i].touched = val.touched;
                }
                gamepadInfoArray[j].buttons[i].value = val.value;
            }
        }
        for(var i1 = 0; i1 < controller.axes.length; i1++){
            var _j1;
            gamepadInfoArray[j] = (_j1 = gamepadInfoArray[j]) !== null && _j1 !== void 0 ? _j1 : [];
            var _axis;
            gamepadInfoArray[j].axis = (_axis = gamepadInfoArray[j].axis) !== null && _axis !== void 0 ? _axis : [];
            gamepadInfoArray[j].axis[i1] = controller.axes[i1];
        }
    }
    if (gamepadInfoArray[0] != null) {
        const gamepadInfo = gamepadInfoArray[0];
        var _value, _value1, _value2, _value3, _value4, _value5, _value6, _value7, _value8, _value9, _value10, _value11, _value12, _value13, _value14, _value15, ref, ref1, ref2, ref3;
        sendGamepadData(gamepadInfo.buttons.length >= 1 ? (_value = gamepadInfo.buttons[0].value) !== null && _value !== void 0 ? _value : 0 : 0, gamepadInfo.buttons.length >= 2 ? (_value1 = gamepadInfo.buttons[1].value) !== null && _value1 !== void 0 ? _value1 : 0 : 0, gamepadInfo.buttons.length >= 3 ? (_value2 = gamepadInfo.buttons[2].value) !== null && _value2 !== void 0 ? _value2 : 0 : 0, gamepadInfo.buttons.length >= 4 ? (_value3 = gamepadInfo.buttons[3].value) !== null && _value3 !== void 0 ? _value3 : 0 : 0, gamepadInfo.buttons.length >= 5 ? (_value4 = gamepadInfo.buttons[4].value) !== null && _value4 !== void 0 ? _value4 : 0 : 0, gamepadInfo.buttons.length >= 6 ? (_value5 = gamepadInfo.buttons[5].value) !== null && _value5 !== void 0 ? _value5 : 0 : 0, gamepadInfo.buttons.length >= 7 ? (_value6 = gamepadInfo.buttons[6].value) !== null && _value6 !== void 0 ? _value6 : 0 : 0, gamepadInfo.buttons.length >= 8 ? (_value7 = gamepadInfo.buttons[7].value) !== null && _value7 !== void 0 ? _value7 : 0 : 0, gamepadInfo.buttons.length >= 9 ? (_value8 = gamepadInfo.buttons[8].value) !== null && _value8 !== void 0 ? _value8 : 0 : 0, gamepadInfo.buttons.length >= 10 ? (_value9 = gamepadInfo.buttons[9].value) !== null && _value9 !== void 0 ? _value9 : 0 : 0, gamepadInfo.buttons.length >= 11 ? (_value10 = gamepadInfo.buttons[10].value) !== null && _value10 !== void 0 ? _value10 : 0 : 0, gamepadInfo.buttons.length >= 12 ? (_value11 = gamepadInfo.buttons[11].value) !== null && _value11 !== void 0 ? _value11 : 0 : 0, gamepadInfo.buttons.length >= 13 ? (_value12 = gamepadInfo.buttons[12].value) !== null && _value12 !== void 0 ? _value12 : 0 : 0, gamepadInfo.buttons.length >= 14 ? (_value13 = gamepadInfo.buttons[13].value) !== null && _value13 !== void 0 ? _value13 : 0 : 0, gamepadInfo.buttons.length >= 15 ? (_value14 = gamepadInfo.buttons[14].value) !== null && _value14 !== void 0 ? _value14 : 0 : 0, gamepadInfo.buttons.length >= 16 ? (_value15 = gamepadInfo.buttons[15].value) !== null && _value15 !== void 0 ? _value15 : 0 : 0, gamepadInfo.axis.length >= 1 ? (ref = gamepadInfo.axis[0]) !== null && ref !== void 0 ? ref : 0 : 0, gamepadInfo.axis.length >= 2 ? (ref1 = gamepadInfo.axis[1]) !== null && ref1 !== void 0 ? ref1 : 0 : 0, gamepadInfo.axis.length >= 3 ? (ref2 = gamepadInfo.axis[2]) !== null && ref2 !== void 0 ? ref2 : 0 : 0, gamepadInfo.axis.length >= 4 ? (ref3 = gamepadInfo.axis[3]) !== null && ref3 !== void 0 ? ref3 : 0 : 0);
    }
};
const addGamepad = (e)=>{
    const controllers = worldViewerWindow.getGamepadControllers();
    controllers[e.gamepad.index] = e.gamepad;
};
const removeGamepad = (e)=>{
    const controllers = worldViewerWindow.getGamepadControllers();
    const gamepadInfoArray = worldViewerWindow.getGamepadInfoArray();
    delete controllers[e.gamepad.index];
    delete gamepadInfoArray[e.gamepad.index];
};
/**
 * @remarks
 * ゲームパッドを扱う
 */ export const initializeGamePad = ()=>{
    if ('GamepadEvent' in window) {
        window.addEventListener("gamepadconnected", addGamepad);
        window.addEventListener("gamepaddisconnected", removeGamepad);
    } else if ('WebKitGamepadEvent' in window) {
        window.addEventListener("webkitgamepadconnected", addGamepad);
        window.addEventListener("webkitgamepaddisconnected", removeGamepad);
    }
};
